import { truckPartsListQuerySchema } from '@chukua/common';
import { useCallback } from 'react';
import { PartsRegisterTable } from '../components/PartsRegisterTable';
import { listTruckParts } from '../parts.api';

/** The Parts tab of a truck's own page: what was fitted to this truck, newest first. */
export function TruckPartsTab({ truckId }: { truckId: string }) {
  const fetchPage = useCallback((query: Parameters<typeof listTruckParts>[1]) => listTruckParts(truckId, query), [truckId]);

  return (
    <PartsRegisterTable
      schema={truckPartsListQuerySchema}
      fetchPage={fetchPage}
      showTruck={false}
      emptyDescription="Parts recorded on this truck's work orders appear here, with the odometer, supplier and work order."
      searchPlaceholder="Search part, serial, work order or supplier"
    />
  );
}
